export default {
  id: 238,
  title: 'Target #238 - Rising sun',
  url: 'https://cssbattle.dev/play/238',
  colors: ['#FEFF58', '#D2F8FF', '#CF6939', '#000000'],
  solution:
    '<style>body{background:conic-gradient(from 90deg at 50px 40px,transparent 90deg,#feff58 90deg),conic-gradient(from 270deg at 350px 260px,transparent 90deg,#feff58 90deg),linear-gradient(#000 40px 50px,transparent 50px 145px,#000 145px 155px,transparent 155px 250px,#000 250px),linear-gradient(90deg,#000 60px,transparent 60px 195px,#000 195px 205px,transparent 205px 340px,#000 340px),radial-gradient(circle at 200px 250px,#cf6939 140px,transparent 140px) #d2f8ff',
}
